import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { UnidadOrgService } from '../../../services/formulacion/unidad-org.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { DireccionAdministrativaService } from '../../../services/service.index';
declare const toastr: any;
@Component({
  selector: 'app-unidad-organizacional',
  templateUrl: './unidad-organizacional.component.html',
  styleUrls: [],
  providers: [UnidadOrgService]
})
export class UnidadOrganizacionalComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  tipo: any[];
  dataResourceUO: any[];
  listDA: any[];
  codigoDA: number;
  model: any = {
    id: 0,
    codigo: '',
    direccion_administrativa_id: '',
    codigo_unidad_ejecutora: '',
    codigo_unidad_ejecutora_sigep: '',
    sigla: '',
    descripcion: '',
    tipo_id: '',
    padre_id: '',
    vigente: true
  };
  uoId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;

  constructor(private _uos: UnidadOrgService, private _das: DireccionAdministrativaService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.tipo = [{ id: 1, descripcion: 'Despacho' }, { id: 2, descripcion: 'Viceministerio' }, { id: 3, descripcion: 'Dirección' }, { id: 4, descripcion: 'Unidad' }, { id: 5, descripcion: 'Laboratorio' }, { id: 6, descripcion: 'Equipo' }];
    this.clearErrors();
    this.getUnidadOrganizacional();
    this.getListDA();
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo_unidad_ejecutora: false, sigla: false, descripcion: false, padre_id: false, codigo_unidad_ejecutora_sigep: false, direccion_administrativa_id: false };
  }

  /**
   * método para listar todos los codigos Sisin
   */
  getListDA() {
    this._das.getDireccionAdministrativaActivo().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.listDA = result.data;
        } else {
          this.listDA = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  /**
   * método para obtener un codigo sisin por Id
   * @param id 
   */
  getCodigoDA(id: any) {
    this._das.getDireccionAdministrativaById(id.value).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.codigoDA = result.data.codigo;
          this.model.codigo_unidad_ejecutora_sigep = result.data.codigo;
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  getUnidadOrganizacional() {
    this._uos.getUnidadOrgconDA().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceUO = result.data;
        } else {
          this.dataResourceUO = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    //this.model.codigo = '';
    this.model.codigo_unidad_ejecutora = '';
    this.model.codigo_unidad_ejecutora_sigep = ''; 
    this.model.direccion_administrativa_id = ''; 
    this.model.sigla = '';
    //this.model.tipo_id = '';
    this.model.descripcion = '';
    this.model.padre_id = '';
    this.model.vigente = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
      
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.codigo_unidad_ejecutora = data.codigo_unidad_ejecutora;
    this.model.direccion_administrativa_id = data.direccion_administrativa_id;
    this.model.codigo_unidad_ejecutora_sigep = data.codigoda;

    this.model.sigla = data.sigla;
    
    this.model.descripcion = data.descripcion;
    this.model.padre_id = data.padre_id;
    this.model.vigente = data.vigente;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  saveUnidadOrganizacional() {
    this.clearErrors();    
    
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._uos.postUnidadOrg(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getUnidadOrganizacional();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._uos.putUnidadOrg(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getUnidadOrganizacional();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
    else
      toastr.warning('Existen errores, revise el formulario...');
  }

  showModalDelete(id: number) {
    this.uoId = id;
    this.popupVisibleDel = true;
  }

  deleteUnidadOrganizacional() {
    this.popupVisibleDel = false;
    this._uos.postUnidadOrg(this.uoId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          toastr.success('Proceso realizado correctamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    // if (!UtilHelper.validator(data.codigo, 'text')) {
    //   this.hasError.codigo = true; res = false;
    // }    
    if (!UtilHelper.validator(data.codigo_unidad_ejecutora, 'text')) {
      this.hasError.codigo_unidad_ejecutora = true; res = false;
    }
    if (!UtilHelper.validator(data.sigla, 'text')) {
      this.hasError.sigla = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    if (!UtilHelper.validator(data.padre_id, 'integer') || (data.direccion_administrativa_id == null)) {
      this.hasError.padre_id = true; res = false;
    }
    //begin jquisbert validaciones nuevos campos 07/2022
    if (!UtilHelper.validator(data.direccion_administrativa_id, 'integer') || (data.direccion_administrativa_id == null)) {
      this.hasError.direccion_administrativa_id = true; res = false;
    }
    if (!UtilHelper.validator(data.codigo_unidad_ejecutora_sigep, 'text') || (data.codigo_unidad_ejecutora_sigep == null)) {
      this.hasError.codigo_unidad_ejecutora_sigep = true; res = false;
    }
    //end
    return res;
  }
}
